/** What the Designer's release list and the control center's both say about a release. */

export default {
	releases: {
		changelog: {
			title: "Changes",
			added: "Added",
			changed: "Changed",
			removed: "Removed",
			empty: "No changes to the model.",
		},
		origin: {
			local: "Made here",
			imported: "Imported",
		},
		build: {
			available: "Runnable",
			availableNote: "Its build is on this server, so a dataspace can run it.",
			missing: "No build",
			missingNote: "Its build is not on this server, so no dataspace can run it.",
		},
		export: {
			action: "Export",
			label: "Export {version}",
			buildMissing:
				"This release's build is no longer on the server, so it cannot be exported.",
		},
	},
};
